import React, { useContext } from 'react';
import InvitationAuthContext from 'src/contexts/InvitationAuthContext';

const useInvitationAuth = () => useContext(InvitationAuthContext);

export default useInvitationAuth
